export default {
  新增模板: "新增模板",
  评估物料: "評估物料",
  评估阶段: "評估階段",
  评估维度: "評估維度",
  评估项: "評估項",
  评估物料类别: "評估物料類別",
  评估阶段_标题: "評估階段",
  取消: "取消",
  保存: "保存",
  新增评估阶段: "+ 新增評估階段",
  请输入评估物料类别: "請輸入評估物料類別",
  请完善表单信息: "請完善表單資訊",
  保存成功: "保存成功",
  保存失败: "保存失敗",
  加载中: "載入中...",
  序号: "序號",
  评估部门: "評估部門",
  评估等级: "評估等級",
  等级描述: "等級描述",
  操作: "操作",
  暂无评估项: "暫無評估項，請點擊下方按鈕添加",
  添加: "+ 添加",
  请输入: "請輸入",
  请选择: "請選擇",
  请输入评估项: "請輸入評估項",
  请选择评估部门: "請選擇評估部門",
  确认删除: "確認刪除",
  确定删除模板: "確定要刪除該評估模板嗎？",
  确定: "確定",
  删除成功: "刪除成功",
  删除失败: "刪除失敗",
  删除维度: "刪除維度",
  请输入评估维度: "請輸入評估維度",
  评估阶段_占位符: "評估階段",
  删除阶段: "刪除階段",
  新增维度: "+ 新增維度",
  请输入评估阶段: "請輸入評估階段",
  评估标准: "評估標準",
  等级: "等級",
  描述: "描述",
  评估部门_表头: "評估部門",
};
